<template>
  <b-card no-body>
    <b-table
      ref="table"
      class="bg-white"
      responsive
      show-empty
      :fields="fields"
      :items="items"
    >
      <template #empty>
        <p align="center">
          <span v-if="!busy">{{ trans('none') }}</span>
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
            {{ trans('please_wait') }}
          </span>
        </p>
      </template>
      <template #cell(name)="data">
        <span :class="`${data.item.has_passed ? 'text-muted' : ''}`">
          {{ data.value }}
        </span>
      </template>
      <template #cell(start)="data">
        <span :class="`${data.item.has_passed ? 'text-muted' : ''}`">
          {{ data.value }}
        </span>
      </template>
      <template #cell(events)="data">
        <small v-for="e in data.value" :key="e.id" :class="`d-block ${data.item.has_passed ? 'text-muted' : ''}`">
          {{ eventToString(e) }}
        </small>
      </template>
      <template #cell(action)="data">
        <b-button
          v-if="!data.item.has_passed"
          variant="link"
          size="sm"
          class="p-0 text-danger"
          @click="onClickCancel(data.item)"
        >
          {{ trans('cancel') }}
        </b-button>
      </template>
    </b-table>
    <div v-if="passedCount > 0" class="pb-4 pt-0 text-center">
      <b-button variant="link" @click="show_passed = ! show_passed">
        {{ trans('passed') }} ({{ passedCount }})
        <i :class="`fa fa-fw fa-caret-${show_passed ? 'up' : 'down'}`"></i>
      </b-button>
    </div>
    <client-cancel-booking-modal
      :organization="organization"
      :booking="booking"
      @cancelled="fetch"
    ></client-cancel-booking-modal>
  </b-card>
</template>

<script>
  import ClientCancelBookingModal from './ClientCancelBookingModal'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      ClientCancelBookingModal,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        busy: false,
        error: null,
        fields: [
          {
            key: 'name',
            label: trans('name'),
            formatter(value, key, item) {
              return (value||'').split('@')[0]
            },
          },
          {
            key: 'start',
            label: trans('date'),
            formatter(value, key, item) {
              return moment(value).format('lll')
            }
          },
          {
            key: 'events',
            label: trans('events'),
          },
          {key: 'action', label: ''},
        ],
        show_passed: false,
        bookings: null,
        booking: null,
      }
    },
    computed: {
      startOfDay() {
        return moment().startOf('day')
      },
      items() {
        return _.reduce(this.bookings || [], (bookings, booking) => {
          if (this.show_passed || !booking.has_passed) bookings.push(booking)
          return bookings
        }, [])
      },
      passedCount() {
        return _.reduce(this.bookings || [], (count, booking) => {
          if (booking.has_passed) count += 1
          return count
        }, 0)
      }
    },
    methods: {
      eventToString(event) {
        return _.compact([
          event.location_name,
          '@',
          _.timeRangeStr(event.start, event.end),
        ]).join(' ')
      },
      onClickCancel(booking) {
        this.booking = booking
        this.$bvModal.show('client-cancel-booking-modal')
      },
      processBookings(data) {
        return _.map(data, booking => {
          booking.has_passed = moment(booking.start).isBefore(this.startOfDay)
          return booking
        })
      },
      fetch() {
        this.busy = true
        this.error = null
        let query = `?page=${this.currentPage}&per_page=${this.perPage}`
        let url = `/org/${this.organization.id}/client/bookings${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.bookings = this.processBookings(response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.bookings = []
        })
      },
    },
    mounted() {
      window.myBookings = this
      this.fetch()
    },
  }
</script>